import { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { login } from "../components/Auth";
import { useLoading } from "../components/LoadingContext";

function AutoLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const { loading, startLoading, finishLoading } = useLoading();
  const [error, setError] = useState("");

  useEffect(() => {
    const doAutoLogin = async () => {
      const params = new URLSearchParams(location.search);
      const loginCode = params.get("login_code");

      if (!loginCode) {
        setError("ログインコードが見つかりません。");
        navigate("/login");
        return;
      }

      startLoading();

      try {
        await login(loginCode);
        navigate("/");
      } catch (e) {
        setError("自動ログインに失敗しました。");
        navigate("/login");
      } finally {
        finishLoading();
      }
    };

    doAutoLogin();
  }, []);

  return (
    <div className="login-container">
      <h1>自動ログイン中...</h1>
      {error && <p className="error">{error}</p>}
      {loading && (
        <div className="overlay-spinner">
          <div className="spinner-icon" />
          <p>Loading...</p>
        </div>
      )}
    </div>
  );
}

export default AutoLogin;
